import { CommunicationCategoryCodes, QuiltedHealthCodeSystems } from "@/fhir/enums/quilted-health";

export const COMMUNICATION_INBOX_CATEGORY = `${QuiltedHealthCodeSystems.CommunicationCategories}|${CommunicationCategoryCodes.Inbox}`;
export const COMMUNICATION_THREAD_CATEGORY = `${QuiltedHealthCodeSystems.CommunicationCategories}|${CommunicationCategoryCodes.Thread}`;

/** Upper bound for the inbox searches, which load every matching thread in one page. */
export const INBOX_SEARCH_MAX_COUNT = 10_000;
